import { deriveKpis } from './agenda-adapter';

import type { AppointmentWireItem } from '../../lib/api-client';
import type { JSX } from 'react';

/**
 * CalendarKpis — 5 contadores honestos derivados do range carregado (D3).
 * Sem endpoint de métrica dedicado; tudo client-side do conjunto visível.
 */
export function CalendarKpis({
  appts,
  nowMs,
}: {
  appts: AppointmentWireItem[];
  nowMs: number;
}): JSX.Element {
  const k = deriveKpis(appts, nowMs);
  const items: { num: number; label: string; tone?: 'warn' | 'danger' }[] = [
    { num: k.today, label: 'hoje' },
    { num: k.week, label: 'esta semana' },
    { num: k.awaitingConfirmation, label: 'aguardando confirmação', tone: 'warn' },
    { num: k.noShow, label: 'faltas no período', tone: 'danger' },
    { num: k.upcomingConfirmed, label: 'próximos confirmados' },
  ];
  return (
    <div className="cal-kpis">
      {items.map((it) => (
        <div key={it.label} className="cal-kpis__item">
          <span
            className={
              'cal-kpis__num' +
              (it.tone === 'warn' && it.num > 0 ? ' cal-kpis__num--warn' : '') +
              (it.tone === 'danger' && it.num > 0 ? ' cal-kpis__num--danger' : '')
            }
          >
            {it.num}
          </span>
          <span className="cal-kpis__lbl">{it.label}</span>
        </div>
      ))}
    </div>
  );
}
